<template>
  <div class="entity-metric" :class="{ 'entity-metric--highlight': highlight }">
    <div class="entity-metric__label">{{ label }}</div>
    <div class="entity-metric__value">{{ value }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EntityDetailMetric",
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true },
    highlight: { type: Boolean, default: false },
  },
});
</script>

<style scoped lang="scss">
.entity-metric {
  padding: 14px 16px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.entity-metric--highlight {
  background: linear-gradient(135deg, #fef2f2 0%, #fff 100%);
  border-color: rgba(229, 24, 61, 0.15);
}

.entity-metric__label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 4px;
}

.entity-metric__value {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1f243f;
  word-break: break-word;
}
</style>
